export default __webpack_public_path__ + "static/media/icn-fuel-pistol.50169856.svg";